import { TProductId } from 'models/subscriptions.model'

import { ScreenName, eventLogger } from 'services/eventLogger.service'
import { googleAnalyticsLogger } from 'services/googleAnalytics.service'

import { getAxonItem } from 'modules/payment/helpers/getAxonItem'

import { PaymentMethod, PaymentSystem } from '../constants'

export const logSuccessfulPayment = ({
  email,
  productId,
  productKey,
  price,
  screenName,
  currency,
  periodName,
  periodQuantity,
  trialPrice,
  predictedLtv,
  trialPeriodDays,
  subscriptionId,
  discountApplied,
  uuid,
  paymentMethod,
  paymentSystem,
  stripeAccountName,
  stripeAccountId,
  isPersonalDataAllowed,
}: {
  email: string
  productId: TProductId
  productKey?: string
  price: number
  screenName: ScreenName
  currency?: string
  periodName: string
  periodQuantity: number
  trialPrice?: number
  predictedLtv?: number
  trialPeriodDays?: number
  subscriptionId: string
  discountApplied?: string
  uuid: string
  paymentMethod?: PaymentMethod
  paymentSystem: PaymentSystem
  stripeAccountName?: string
  stripeAccountId?: string
  isPersonalDataAllowed: boolean
}): void => {
  if (trialPeriodDays && screenName !== ScreenName.UPSELL_OFFER) {
    window.fbq(
      'track',
      'StartTrial',
      {
        value: trialPrice,
        currency,
        subscription_id: subscriptionId,
        // This field and similar ones below have been added to avoid FB pixel issue. https://github.com/facebook/facebook-nodejs-business-sdk/issues/164
        subscription_sid: subscriptionId,
      },
      { eventID: uuid },
    )
  }

  if (screenName !== ScreenName.UPSELL_OFFER) {
    window.fbq(
      'track',
      'Purchase',
      {
        value: predictedLtv || trialPrice || price,
        currency,
        subscription_id: subscriptionId,
        subscription_sid: subscriptionId,
      },
      { eventID: uuid },
    )

    window.fbq(
      'track',
      'Subscribe',
      {
        value: trialPrice || price,
        currency,
        subscription_id: subscriptionId,
        subscription_sid: subscriptionId,
      },
      { eventID: uuid },
    )

    window.snaptr &&
      window.snaptr('track', 'PURCHASE', {
        price: trialPrice || price,
        currency,
        client_dedup_id: subscriptionId,
        transaction_id: subscriptionId,
        user_email: isPersonalDataAllowed ? email : '',
      })
    window.ttq.track('CompletePayment', {
      value: trialPrice || price,
      currency: currency?.toUpperCase(),
      content_id: subscriptionId,
    })
    googleAnalyticsLogger.logPurchaseCompleted({
      subscriptionId,
      price: trialPrice || price,
      productId,
      currency,
    })
  }

  window.axon &&
    window.axon('track', 'purchase', {
      value: trialPrice || price,
      currency: currency?.toUpperCase(),
      user_id: isPersonalDataAllowed ? uuid : '',
      transaction_id: subscriptionId,
      items: [
        getAxonItem({
          id: subscriptionId,
          periodQuantity,
          periodName,
          trialPrice,
          price,
        }),
      ],
    })

  window.ttq.identify({ email: isPersonalDataAllowed ? email : '' })

  eventLogger.logPurchaseCompleted({
    email,
    screenName,
    productId,
    productKey,
    priceDetails: {
      price,
      trial: !!trialPrice,
      currency,
    },
    paymentMethod,
    transactionId: subscriptionId,
    paymentSystem,
    stripeAccountName,
    stripeAccountId,
    isPersonalDataAllowed,
    ...(discountApplied && { discountApplied }),
  })
}
